import type { MisconceptionDefinition } from '../types';
import { GELD_BASIS } from './basis';
import { GELD_KORTING } from './korting';
import { GELD_BTW } from './btw';
import { GELD_WISSEL } from './wissel';
import { GELD_TELLEN } from './tellen';
export const GELD_MISCONCEPTIONS: MisconceptionDefinition[] = [...GELD_BASIS, ...GELD_KORTING, ...GELD_BTW, ...GELD_WISSEL, ...GELD_TELLEN];